import { UserMapNode } from "./Nodes/UserMapNode";
import { ActionStateEnum, CreateWallState, EditPointState, IdleVisualiseState } from "../state";
import { EntityManager } from "./EntityManager";
import { AngleNode } from "./Nodes/AngleNode";
import { SafeZoneNode } from "./Nodes/SafeZoneNode";
import { JunctionPointNode } from "./Nodes/JunctionPointNode";
import { JoineryExtremitiesNode } from "./Nodes/JoineryExtremitiesNode";
import { DimensionNode } from "./Nodes/DimensionNode";
import { Utils } from "../utils/Utils";
import { FrontViewManager } from "./FrontViewManager";
import { FunctionalityChipNode } from "./Nodes/FunctionalityChipNode";
import { EntityNode } from "./EntityNodes/EntityNode";
import { Plan2DConstantes } from "./PlanManager";
import { WallNode } from "./EntityNodes/WallNode";
import { PlanManager } from "../../../cocosPlan";
import { arrangementManager, EntityDefaultPropertiesManager, Events, eventsManager, FunctionalityChip, Joinery, joineryManager, math, Room, SavaneConstants, SavaneMath, SceneConstants, Wall, wallManager } from "@rhinov/savane-js";

declare var cc: any;

export class GameObjectManager {

    static roomFunctionalitiesData = {};
    static dimensionClicked: DimensionNode | null = null;
    static dimensionClickedType: number = -1;
    static objectOfClickedDimension: object | null = null;
    static DimensionType = {
        Joinery1: 0,
        Joinery2: 1,
        Joinery3: 2,
        Walls: 3,
        TechElement: 4
    };
    static beginMeasure: math.vec3 | null = null;

    constructor() {
        

    }

    // Function that converts cocos plan coordinates to savane coordinates, returns a vec3
    static retrieveFromCocosCoord(point: {x: number, y: number}): math.vec3{
        var p = math.vec3.create();
        math.vec3.set(p, point.x * 10, point.y * 10, 0);
        return p;
    };

    // Function that converts savane coordinates to cocos plan coordinates
    static convertToCocosCoord(point: math.vec3 | math.vec2) {
        return new cc.p(point[0] / 10, point[1] / 10);
    };

    // Function that free an already loaded user map
    static deleteUserMap() {
        var userMap = PlanManager.getInstance().scrollWindow.grid.getChildByName('UserMap');
        if (userMap !== null) {
            userMap.removeFromParent();
        }
    };

    static scaleUserMap(scale: number) {
        var userMap = PlanManager.getInstance().scrollWindow.grid.getChildByName('UserMap');
        if (userMap !== null) {
            userMap.setScale(scale, scale);
        }
    };

    static getScaleUserMap(): number {
        var userMap = PlanManager.getInstance().scrollWindow.grid.getChildByName('UserMap') as UserMapNode;
        if (userMap !== null) {
            return (userMap.scaleX);
        }
        return 1;
    };

    static updateOpacity(value: number) {
        var userMap = PlanManager.getInstance().scrollWindow.grid.getChildByName('UserMap');
        if (userMap !== null) {
            userMap.children[0].setOpacity(value);
        }
    };

    static offsetUserMap (offset: number) {
        var userMap = PlanManager.getInstance().scrollWindow.grid.getChildByName('UserMap');
        if (userMap !== null) {
            userMap.setPosition(offset);
        }
    };

    /**
     * Apply an image to background as a plan and using scale set by user
     * @param texture
     * @param scale
     */
    static createUserMap (texture: any, scale: number, userScale: number, rotate: number, offset?: math.vec2) {
        this.deleteUserMap();

        //todo ubly fix for textrue === ""
        if (texture !== null && texture !== undefined && texture.length > 10) {
            var sprite = new UserMapNode();
            var layer = cc.Sprite.create();
            layer.setName('UserMap');
            if (offset) {
                layer.setPosition(this.convertToCocosCoord(offset));
            }
            if (userScale) {
                layer.setScale(userScale);
            }
            layer.setOpacity(255);
            //sprite.setTexture(texture);
            sprite.initUserMap(texture, scale);
            sprite.setColor(Plan2DConstantes.usermapColorMask);
            if (PlanManager.getInstance().world.name !== 'importedPlan') {
                sprite.setOpacity(PlanManager.getInstance().opacity || 75);
            }
            //sprite.setScale(scale);
            sprite.setName('mapSprite');
            sprite.setRotation(rotate);
            sprite.setVisible(PlanManager.getInstance()._backgroundVisibility);

            var scrollWindow = PlanManager.getInstance().scrollWindow;
            layer.addChild(sprite, -5);
            scrollWindow.addChild(layer, 0.7);
            scrollWindow.refreshGrid();
            var testLoad = function() {
                var scrollWindow = PlanManager.getInstance().scrollWindow;
                if (scrollWindow.grid === null || !scrollWindow || scrollWindow.grid.getChildByName('UserMap') === null) {
                    return;
                }
                var userMap = scrollWindow.grid.getChildByName('UserMap').getChildByName('mapSprite');
                if (userMap === null) {
                    return;
                }
                if (userMap.textureLoaded()) {
                    var fullDist = userMap.getContentSize().width * userMap.realScale;
                    var windowWidth = window.screen.width / window.devicePixelRatio
                    if (fullDist > windowWidth) {
                        if (fullDist > windowWidth * 20) {
                            PlanManager.getInstance().scrollWindow.buildZoomScale(0.025);
                        } else if (fullDist > windowWidth * 6) {
                            PlanManager.getInstance().scrollWindow.buildZoomScale(0.1);
                        } else if (fullDist > windowWidth * 2) {
                            PlanManager.getInstance().scrollWindow.buildZoomScale(0.25);
                        } else {
                            PlanManager.getInstance().scrollWindow.buildZoomScale(0.4);
                        }
                        PlanManager.getInstance().scrollWindow.centerPosition(false, false);
                    }

                    if (PlanManager.getInstance()._state.state === ActionStateEnum.idleVisualise)
                        (PlanManager.getInstance()._state as unknown as IdleVisualiseState).lockViewNoOffset();
                } else {
                    setTimeout(testLoad, 200);
                }
            };
            setTimeout(testLoad, 200);
        }
    };

    static getBaseWalls (wallPoint: math.vec3) {
        const currentFloor = PlanManager.getInstance().world.currentScene?.currentFloor;
        if (!currentFloor) {
            return [];
        }
        var walls = wallManager.getWallsAtPosition(wallPoint, currentFloor, SavaneConstants.PositionTolerance, 0);
        if (walls === null) {
            walls = [];
        }
        for (var i = walls.length - 1; i >= 0; i--) {
            if (!walls[i].isValid(currentFloor)) {
                walls.splice(i, 1);
            }
        }
        return walls;
    };

    static drawWall (wall: any, isValid: any, isSelected: any, isRoom?: any, roomSelectedId?: any, cuttingWall?: any): WallNode {
        if (cuttingWall === undefined) {
            cuttingWall = null;
        }
        //Retrieve wall in grid
        var wallNode: EntityNode | null = EntityManager.getInstance().getNode(wall);
        if (wallNode === null) {
            wallNode = EntityManager.getInstance().createNode(wall, true);
            if (wallNode !== null) {
                wallNode.setAnchorPoint(0.5, 0.5);
            }
        }

        if (wallNode !== null) {
            // Force the wall node to redraw
            wallNode.needRedraw = true;
        }

        // FOrce the joineries to redraw too
        for (var i = 0; i < wall.joineries.length; i++) {
            var node = EntityManager.getInstance().getNode(wall.joineries[i]);

            if (node !== null) {
                node.needRedraw = true;
            }
        }

        //Retrieve position value
        var begin = this.convertToCocosCoord(wall.begin);
        var end = this.convertToCocosCoord(wall.end);
        var length = new cc.p((end.x - begin.x), (end.y - begin.y));
        var middle = { x: begin.x + length.x * 0.5, y: begin.y + length.y * 0.5 };
        var lengthDistance = Math.sqrt((length.x * length.x) + (length.y * length.y));

        //Update wallNode infos
        //wallNode.setPosition(middle);
        wallNode!.setDimWall(lengthDistance, (wall.thickness / 10));
        var angleDegree = wall.getWallAngle(true) * 360.0 / (Math.PI * 2.0);
        //wallNode.setRotation(angleDegree);
        wallNode!.setSelected(isSelected);
        wallNode!.setValidity(isValid);
        wallNode!.setCuttingWall(cuttingWall);

        wallNode!.update(undefined);

        return wallNode as WallNode;
    };

    /**
     * Helper function to check if a given node exists
     * @param name
     * @returns {boolean}
     */
    static exist(name: string): boolean {
        var layer = PlanManager.getInstance().scrollWindow;
        var node = layer.grid.getChildByName(name);
        return node !== null;
    };

    /**
     * createCircle helper function
     *
     * @param name
     * @param pos
     * @param radius
     * @param color
     */
    static createCircle (name: any, pos: any, radius: any, color: any) {
        var layer = PlanManager.getInstance().scrollWindow;

        var circle = new cc.DrawNode();
        circle.setName(name);
        circle.setPosition(pos);
        circle.drawCircle(new cc.p(0, 0), radius, Math.PI * 2, 64, false, 1, color);
        layer.addChild(circle, 2.5);

        return circle;
    };

    static drawAngle (wall1: any, wall2: any, zoom: any): AngleNode {
        var layer = PlanManager.getInstance().scrollWindow;
        //Retrieve wall in grid
        var angleNode = layer.grid.getChildByName('angle' + wall1.id);
        var point = SavaneMath.findCommonPoint(wall1, wall2);
        if (angleNode === null) {
            zoom = zoom < 0.5 ? 0.5 : zoom;
            angleNode = new AngleNode(zoom);
            angleNode.setScale(1.3 / Math.sqrt(zoom));

            angleNode.setPosition(new cc.p(point[0] / 10, point[1] / 10));
            angleNode.setName('angle' + wall1.id);
            layer.addChild(angleNode, 10);
        }
        else {
            angleNode.setPosition(new cc.p(point[0] / 10, point[1] / 10));
        }
        var angle1 = wall1.getWallAngle(wall1.isBegin(point));
        var angle2 = wall2.getWallAngle(wall2.isBegin(point));
        angleNode.updateDrawing(angle1, angle2);

        //junctionPointNode.drawPoint(layer.getZoomScale());
        return angleNode;
    };

    static deleteAngle (wall1: Wall) {
        var layer = PlanManager.getInstance().scrollWindow;
        var node = layer.grid.getChildByName('angle' + wall1.id);
        if (node !== null) {
            node.removeFromParent();
            node.removeListener();
        }
    };

    static createJunctionPoint (position: any, zoom: any, name: any, walls: any): JunctionPointNode | undefined {
        // If in decoration state, then let's not display moveable icon over the element
        if (PlanManager.getInstance().getAction() === ActionStateEnum.idleDecoration) {
            return undefined;
        }
        for (var i = 0; i < walls.length; i++) {
            if (walls[i].locked) {
                return undefined;
            }
        }

        var layer = PlanManager.getInstance().scrollWindow;
        //Retrieve wall in grid
        var junctionPointNode = layer.grid.getChildByName(name);
        if (junctionPointNode === null) {
            junctionPointNode = new JunctionPointNode(true);
            junctionPointNode.setName(name);
            zoom = zoom < 0.5 ? 0.5 : zoom;
            junctionPointNode.setScale(0.7 / Math.sqrt(zoom));
            layer.addChild(junctionPointNode, 120);
        }
        //junctionPointNode.movable = (movable!==undefined) ? movable : true;
        junctionPointNode.setPosition(position);
        //junctionPointNode.drawPoint(layer.getZoomScale());
        return junctionPointNode;
    };

    static deleteJunctionPoint (name: string) {
        var layer = PlanManager.getInstance().scrollWindow;

        var node = layer.grid.getChildByName(name);
        if (node !== null) {
            node.removeFromParent();
            node.removeListener();
        }
    };

    static createJoineryExtremity (entity: Joinery, position: math.vec3, wall: Wall, name: string): JoineryExtremitiesNode {
        var layer = PlanManager.getInstance().scrollWindow;
        //Retrieve wall in grid
        var junctionPointNode = layer.grid.getChildByName(name);
        if (junctionPointNode === null) {

            junctionPointNode = new JoineryExtremitiesNode(wall, entity);
            junctionPointNode.setName(name);
            layer.addChild(junctionPointNode, EntityManager.getInstance().getLevel(entity) + 1);
        }
        junctionPointNode.computeExtremity(position, wall);
        // junctionPointNode.setPosition(position);
        //  junctionPointNode.drawPoint(layer.getZoomScale());
        return junctionPointNode;
    };

    static deleteJoineryExtremity (name: string) {
        var layer = PlanManager.getInstance().scrollWindow;

        var node = layer.grid.getChildByName(name);
        if (node !== null) {
            node.removeFromParent();
            node.removeListener();
        }
    };

    static getCurrentLayer (deco: any, decoObj: any) {
        if (!deco || deco === undefined) {
            return PlanManager.getInstance().scrollWindow.grid;
        }
        else {
            if (decoObj !== undefined && decoObj !== null) {
                return decoObj;
            }
            else {
                return PlanManager.getInstance().frontViewLayer;
            }
        }
    };

    static createDimension (name: string, label: string, begin: any, end: any, normal: any, dist: any, labelScale: number, deco?: any, decoObj?: any): DimensionNode {
        var layer = this.getCurrentLayer(deco, decoObj);

        //Retrieve wall in grid
        var dimensionNode = layer.getChildByName(name);
        if (dimensionNode === null) {
            dimensionNode = new DimensionNode();
            dimensionNode.setName(name);
            layer.addChild(dimensionNode, 100007);
        }
        var cote_begin = new cc.p(begin.x + dist * normal.x, begin.y + dist * normal.y);
        var cote_end = new cc.p(end.x + dist * normal.x, end.y + dist * normal.y);
        var cote_pos = new cc.p((cote_begin.x + cote_end.x) / 2, (cote_begin.y + cote_end.y) / 2);
        //var middleP = new cc.p(begin.x + (end.x-begin.x)*0.5,begin.y + (end.y-begin.y)*0.5);
        dimensionNode.setPosition(cote_pos);
        var calcDist = Math.sqrt((end.x - begin.x) * (end.x - begin.x) + (end.y - begin.y) * (end.y - begin.y));
        var currentLayer: any = PlanManager.getInstance().scrollWindow;
        if (PlanManager.getInstance().frontViewLayer.isVisible()) {
            currentLayer = PlanManager.getInstance().frontViewLayer;
        }
        dimensionNode.setDimensionValue(calcDist, currentLayer.getZoomScale());
        if (deco === true) {
            dimensionNode.setLocalScale(labelScale);
        }
        var angle = Math.atan2(end.x - begin.x, end.y - begin.y);
        var cocosAngle = (angle + Math.PI * 0.5) * 180 / Math.PI;
        if (cocosAngle < -90.0) cocosAngle += 180;
        if (cocosAngle > 90.0) cocosAngle -= 180;
        dimensionNode.setRotation(cocosAngle);

        return dimensionNode;
    };

    static deleteDimension (name: any, deco?: any, decoObj?: any) {
        var layer = this.getCurrentLayer(deco, decoObj);

        var node = layer.getChildByName(name);
        if (node !== null) {
            node.removeFromParent();
        }
    };

    /**
     * Create the necessary nodes for the ruler
     * @param isSecondRuler
     */
    static createRuler (isSecondRuler: boolean) {
        var layer = PlanManager.getInstance().scrollWindow;
        var ruler = new cc.DrawNode();
        var colorGray = new cc.color(127, 127, 127);

        ruler.setName(isSecondRuler ? 'Ruler1' : 'Ruler');
        ruler.drawSegment(new cc.p(0.0, 0.0), isSecondRuler ? new cc.p(1.0, 0.0) : new cc.p(0.0, 1.0), 1.0, colorGray);
        layer.addChild(ruler, 3);
    };

    /**
     * Cleanup the nodes associated to the ruler.
     *  * @param isSecondRuler
     */
    static deleteRuler (isSecondRuler: boolean) {
        var layer = PlanManager.getInstance().scrollWindow;
        var node;
        if (!isSecondRuler) {
            node = layer.grid.getChildByName('Ruler');
        } else {
            node = layer.grid.getChildByName('Ruler1');
        }
        if (node !== null) {
            node.removeFromParent();
        }
    };

    /**
     * Helper function to determine if both rulers have been created already
     * @returns {boolean}
     */
    static rulerCreated (isSecondRuler: boolean) {
        var layer = PlanManager.getInstance().scrollWindow;
        var ruler;
        if (!isSecondRuler) {
            ruler = layer.grid.getChildByName('Ruler');
        } else {
            ruler = layer.grid.getChildByName('Ruler1');
        }
        return ruler !== null;
    };

    /**
     * Reposition and display the rulers as requested
     * @param pos
     * @param horizontalRuler
     * @param verticalRuler
     */
    static drawRuler (pos: math.vec3) {
        var layer = PlanManager.getInstance().scrollWindow;

        var position = this.convertToCocosCoord(pos);
        var hRuler = layer.grid.getChildByName('Ruler');
        var vRuler = layer.grid.getChildByName('Ruler1');

        if (hRuler !== null) {
            hRuler.setPosition(new cc.p(0, position.y));
            hRuler.setScaleX(5000);
        }

        if (vRuler !== null) {
            vRuler.setPosition(new cc.p(position.x, 0));
            vRuler.setScaleY(5000);
        }
    };

    static setWallColor (wallId: number, isValid: boolean) {
        var obj = EntityManager.getInstance().getNodeById(wallId);

        if (obj !== null)
            obj.setColor(isValid ? Plan2DConstantes.wallvec4Valid : Plan2DConstantes.wallvec4NotValid);
        else
            console.log('setWallColor wall with id wallId=' + wallId + ' not found.');
    };

    static createCutDimension (cursorPos: any, wallCut: any, cursorPosWithoutSnap: any, saved: any) {
        var wallCutNode = EntityManager.getInstance().getNode(wallCut);

        var currentWall: any = undefined;
        var testedPoint = null;
        if (PlanManager.getInstance().state.getAction() === ActionStateEnum.createWall) {
            currentWall = (PlanManager.getInstance().state as unknown as CreateWallState).wall;
            if (currentWall && saved !== undefined) {
                testedPoint = currentWall.end;
            } else if (currentWall) {
                testedPoint = currentWall.begin;
            }
        } else if (PlanManager.getInstance().state.getAction() === ActionStateEnum.editPoint) {
            const editState = (PlanManager.getInstance().state as unknown as EditPointState);
            currentWall = editState.wallsEdited?.[0];
            if (currentWall && editState.editedPoint) {
                testedPoint = currentWall.isEnd(editState.editedPoint) ? currentWall.begin : currentWall.end;
            }
        }

        var sideBot = true;
        var points = wallCut.boundingBox;
        if (points !== null && points !== undefined) {
            if (currentWall !== undefined && currentWall !== null) {
                if (Wall.areColinear(currentWall, wallCut as any))
                    return;
                if (SavaneMath.distanceToLine(testedPoint!, points[1]!, points[2]!) > SavaneMath.distanceToLine(testedPoint!, points[0]!, points[3]!)) {
                    sideBot = false;
                }
            } else {
                if (SavaneMath.distanceToLine(cursorPosWithoutSnap, points[1]!, points[2]!) > SavaneMath.distanceToLine(cursorPosWithoutSnap, points[0]!, points[3]!)) {
                    sideBot = false;
                }
            }
        }

        var normal;
        var dist1;
        var dist2;
        dist1 = math.vec3.dist(wallCut.begin, cursorPos);
        dist2 = math.vec3.dist(wallCut.end, cursorPos);
        normal = cc.p((wallCut.begin[1] - wallCut.end[1]) / (dist1 + dist2), -(wallCut.begin[0] - wallCut.end[0]) / (dist1 + dist2));
        if (sideBot) {
            normal.y *= -1;
            normal.x *= -1;
        }

        var begin = this.convertToCocosCoord(wallCut.begin);
        //Add border offsets according to side
        //TODO Maybe better to not use the graphical node but retrieve boundingboxcut
        var cutBox = wallCut.boundingBoxCut;
        var matrix = wallCut.transform.invertedGlobalMatrix;
        var vertex = [];
        for (var i = 0; i < cutBox.length; i++) {
            math.vec3.transformMat4(cutBox[i], cutBox[i], matrix);
            vertex.push(this.convertToCocosCoord(cutBox[i]));
        }
        if (!sideBot) {
            begin.x += vertex[0].x * normal.y;
            begin.y -= vertex[0].x * normal.x;
        } else {
            begin.x -= vertex[1].x * normal.y;
            begin.y += vertex[1].x * normal.x;
        }
        var end = this.convertToCocosCoord(wallCut.end);
        if (!sideBot) {
            end.x -= ((wallCut.length / 10) - vertex[3].x) * normal.y;
            end.y += ((wallCut.length / 10) - vertex[3].x) * normal.x;
        } else {
            end.x += ((wallCut.length / 10) - vertex[2].x) * normal.y;
            end.y -= ((wallCut.length / 10) - vertex[2].x) * normal.x;
        }

        begin.x += (wallCut.wallDirection[1] * -wallCut.shiftOffset) / 10;
        begin.y += (wallCut.wallDirection[0] * wallCut.shiftOffset) / 10;
        end.x += (wallCut.wallDirection[1] * -wallCut.shiftOffset) / 10;
        end.y += (wallCut.wallDirection[0] * wallCut.shiftOffset) / 10;

        var middle = this.convertToCocosCoord(cursorPos);
        var middle1 = new cc.p();
        var middle2 = new cc.p();
        if (currentWall != undefined) {//Cut with wall in hand
            var currentPoints = currentWall.boundingBox;
            var point1;
            var point2;
            if (sideBot) {
                point1 = SavaneMath.getCrossPoint(points[1], points[2], currentPoints[1], currentPoints[2], 1);
                point2 = SavaneMath.getCrossPoint(points[1], points[2], currentPoints[3], currentPoints[0], 1);
                if (!point1 || !point2) {
                    return;
                }
                if (math.vec3.distance(point1, wallCut.begin) < math.vec3.distance(point2, wallCut.begin)) {
                    middle1.x = point1[0] / 10 - wallCut.wallDirection[1] * wallCut.thickness / 20;
                    middle1.y = point1[1] / 10 + wallCut.wallDirection[0] * wallCut.thickness / 20;
                    middle2.x = point2[0] / 10 - wallCut.wallDirection[1] * wallCut.thickness / 20;
                    middle2.y = point2[1] / 10 + wallCut.wallDirection[0] * wallCut.thickness / 20;
                } else {
                    middle1.x = point2[0] / 10 - wallCut.wallDirection[1] * wallCut.thickness / 20;
                    middle1.y = point2[1] / 10 + wallCut.wallDirection[0] * wallCut.thickness / 20;
                    middle2.x = point1[0] / 10 - wallCut.wallDirection[1] * wallCut.thickness / 20;
                    middle2.y = point1[1] / 10 + wallCut.wallDirection[0] * wallCut.thickness / 20;
                }
            } else {
                point1 = SavaneMath.getCrossPoint(points[0], points[3], currentPoints[1], currentPoints[2], 1);
                point2 = SavaneMath.getCrossPoint(points[0], points[3], currentPoints[3], currentPoints[0], 1);
                if (!point1 || !point2) {
                    return;
                }
                if (math.vec3.distance(point1, wallCut.begin) < math.vec3.distance(point2, wallCut.begin)) {
                    middle1.x = point1[0] / 10 + wallCut.wallDirection[1] * wallCut.thickness / 20;
                    middle1.y = point1[1] / 10 - wallCut.wallDirection[0] * wallCut.thickness / 20;
                    middle2.x = point2[0] / 10 + wallCut.wallDirection[1] * wallCut.thickness / 20;
                    middle2.y = point2[1] / 10 - wallCut.wallDirection[0] * wallCut.thickness / 20;
                } else {
                    middle1.x = point2[0] / 10 + wallCut.wallDirection[1] * wallCut.thickness / 20;
                    middle1.y = point2[1] / 10 - wallCut.wallDirection[0] * wallCut.thickness / 20;
                    middle2.x = point1[0] / 10 + wallCut.wallDirection[1] * wallCut.thickness / 20;
                    middle2.y = point1[1] / 10 - wallCut.wallDirection[0] * wallCut.thickness / 20;
                }
            }
        } else {
            var value = EntityDefaultPropertiesManager.getInstance().wallDefaultProperties.thickness / 20;

            middle1.x = middle.x - (value * wallCut.wallDirection[0]);
            middle1.y = middle.y - (value * wallCut.wallDirection[1]);
            middle2.x = middle.x + (value * wallCut.wallDirection[0]);
            middle2.y = middle.y + (value * wallCut.wallDirection[1]);
        }

        dist1 = Math.sqrt((middle1.x - begin.x) * (middle1.x - begin.x) + (middle1.y - begin.y) * (middle1.y - begin.y));
        dist2 = Math.sqrt((middle2.x - end.x) * (middle2.x - end.x) + (middle2.y - end.y) * (middle2.y - end.y));

        var scale = PlanManager.getInstance().getZoomScale();

        var name = 'CutDimension';
        if (saved) {
            name += 'Saved';
        }

        var distWall = 0.5;

        // If the wall to be cut has at least one joinery added by ETT
        if (wallCut.joineries.length > 0) {
            // Set joineries to display dimension against to none
            var joinery1 = null;
            var joinery2 = null;
            // Loop variable
            var i: number;
            // We create 2 groups, one for the joineries on the left and on for the joineries on the right
            var joineryGroup1 = [];
            var joineryGroup2 = [];
            // We compute the distance to the cursor
            var distToNewWall = math.vec3.dist(wallCut.begin, cursorPos);
            // Get hovered joinery
            const currentFloor = PlanManager.getInstance().world.currentScene?.currentFloor;
            var joineryHovered = currentFloor ? joineryManager.getJoineryAtPosition(cursorPos, SavaneConstants.PositionTolerance, currentFloor) : null;

            // And we parse all joineries
            for (i = 0; i < wallCut.joineries.length; i++) {
                // Distance to created wall > distance to the joinery then group
                if (distToNewWall > math.vec3.dist(wallCut.begin, wallCut.joineries[i].position)) {
                    joineryGroup1.push(wallCut.joineries[i]);
                }
                else {
                    // Else group 2
                    joineryGroup2.push(wallCut.joineries[i]);
                }
            }

            // Find closest distance from group1 to new wall and get joinery1
            if (joineryGroup1.length > 0) {
                // Min distance to the closest group1 joinery
                var minDist = 10000000;

                // Parse all joineries of group1
                for (i = 0; i < joineryGroup1.length; i++) {
                    // Closer, then this might be the closest
                    if (math.vec3.dist(cursorPos, joineryGroup1[i].position) < minDist) {
                        // If not currently hovered
                        if (joineryHovered !== null) {
                            if (joineryGroup1[i].id !== joineryHovered.id) {
                                // Store the joinery as the closest for the moment
                                joinery1 = joineryGroup1[i];
                                minDist = math.vec3.dist(cursorPos, joinery1.position);
                            }
                        }
                        else {
                            // Store the joinery as the closest for the moment
                            joinery1 = joineryGroup1[i];
                            minDist = math.vec3.dist(cursorPos, joinery1.position);
                        }
                    }
                }
            }

            // Find closest distance from group2 to new wall and get joinery2
            if (joineryGroup2.length > 0) {
                // Min distance to the closest group1 joinery
                var minDist = 10000000;

                // Parse all joineries of group2
                for (i = 0; i < joineryGroup2.length; i++) {
                    // Closer, then this might be the closest
                    if (math.vec3.dist(cursorPos, joineryGroup2[i].position) < minDist) {
                        // If not currently hovered
                        if (joineryHovered !== null) {
                            if (joineryGroup2[i].id !== joineryHovered.id) {
                                // Store the joinery as the closest for the moment
                                joinery2 = joineryGroup2[i];
                                minDist = math.vec3.dist(cursorPos, joinery2.position);
                            }
                        }
                        else {
                            // Store the joinery as the closest for the moment
                            joinery2 = joineryGroup2[i];
                            minDist = math.vec3.dist(cursorPos, joinery2.position);
                        }
                    }
                }
            }

            // If the 1st part of the wall has a joinery
            if (joinery1 !== null) {
                var distToWall = math.vec3.dist(wallCut.begin, joinery1.position) - joinery1.length / 2;
                var joineryDist1;
                var joineryDist2;
                var extremity;
                var distance;

                // Beginning point of the joinery
                var beginJ:any = math.vec3.create();
                math.vec3.set(beginJ, wallCut.begin[0] + wallCut.wallDirection[0] * distToWall, wallCut.begin[1] + wallCut.wallDirection[1] * distToWall, 0);
                beginJ = this.convertToCocosCoord(beginJ);

                // Ending point of the joinery
                var endJ: any = math.vec3.create();
                math.vec3.set(endJ, wallCut.begin[0] + wallCut.wallDirection[0] * (distToWall + joinery1.length), wallCut.begin[1] + wallCut.wallDirection[1] * (distToWall + joinery1.length), 0);
                endJ = this.convertToCocosCoord(endJ);

                // Compute distance from new wall to extremities
                joineryDist1 = Math.sqrt((middle1.x - beginJ.x) * (middle1.x - beginJ.x) + (middle1.y - beginJ.y) * (middle1.y - beginJ.y));
                joineryDist2 = Math.sqrt((middle1.x - endJ.x) * (middle1.x - endJ.x) + (middle1.y - endJ.y) * (middle1.y - endJ.y));

                // Check which extremity is the closest (and get the distance to it)
                if (joineryDist1 < joineryDist2) {
                    extremity = beginJ
                    distance = joineryDist1;
                }
                else {
                    extremity = endJ;
                    distance = joineryDist2;
                }

                // Finally display it
                this.createDimension(name + '3', '' + Math.round(distance / 10) + 'cm', extremity, middle1, normal, Utils.DIMENSION_DIST + wallCut.thickness * 0.5 / 10, scale);
            }
            else {
                // Remove the dimensions to joineries
                this.deleteDimension('CutDimension3');

                var layer = PlanManager.getInstance().scrollWindow;
                var node = layer.grid.getChildByName('cutDimensionLayer');
                layer.grid.removeChild(node, true);
            }

            // If the second part of the wall has a joinery
            if (joinery2 !== null) {
                var distToWall = math.vec3.dist(wallCut.begin, joinery2.position) - joinery2.length / 2;
                var joineryDist1;
                var joineryDist2;
                var extremity;
                var distance;

                // Beginning point of the joinery
                var beginJ: any = math.vec3.create();
                math.vec3.set(beginJ, wallCut.begin[0] + wallCut.wallDirection[0] * distToWall, wallCut.begin[1] + wallCut.wallDirection[1] * distToWall, 0);
                beginJ = this.convertToCocosCoord(beginJ);

                // Ending point of the joinery
                var endJ: any = math.vec3.create();
                math.vec3.set(endJ, wallCut.begin[0] + wallCut.wallDirection[0] * (distToWall + joinery2.length), wallCut.begin[1] + wallCut.wallDirection[1] * (distToWall + joinery2.length), 0);
                endJ = this.convertToCocosCoord(endJ);

                // Compute distance from new wall to extremities
                joineryDist1 = Math.sqrt((middle2.x - beginJ.x) * (middle2.x - beginJ.x) + (middle2.y - beginJ.y) * (middle2.y - beginJ.y));
                joineryDist2 = Math.sqrt((middle2.x - endJ.x) * (middle2.x - endJ.x) + (middle2.y - endJ.y) * (middle2.y - endJ.y));

                // Check which extremity is the closest (and get the distance to it)
                if (joineryDist1 < joineryDist2) {
                    extremity = beginJ
                    distance = joineryDist1;
                }
                else {
                    extremity = endJ;
                    distance = joineryDist2;
                }

                // Finally display it
                this.createDimension(name + '4', '' + Math.round(distance / 10) + 'cm', middle2, extremity, normal, Utils.DIMENSION_DIST + wallCut.thickness * 0.5 / 10, scale);
            }
            else {
                // Remove the dimensions to joineries
                this.deleteDimension('CutDimension4');

                var layer = PlanManager.getInstance().scrollWindow;
                var node = layer.grid.getChildByName('cutDimensionLayer');
                layer.grid.removeChild(node, true);
            }

            // If any joinery found and displayed, move the distance to wall dimension a bit further
            if (joinery1 !== null || joinery2 !== null) {
                distWall = 1.5;
            }
        }

        this.createDimension(name + '1', '' + Math.round(dist1 / 10) + 'cm', begin, middle1, normal, Utils.DIMENSION_DIST + wallCut.thickness * distWall / 10, scale);
        this.createDimension(name + '2', '' + Math.round(dist2 / 10) + 'cm', middle2, end, normal, Utils.DIMENSION_DIST + wallCut.thickness * distWall / 10, scale);

        if (currentWall === undefined) {
            var layer = PlanManager.getInstance().scrollWindow;
            var colorDim = layer.grid.getChildByName('cutDimensionLayer');


            if (colorDim === null || colorDim === undefined) {
                colorDim = new cc.DrawNode();
                colorDim.setName('cutDimensionLayer');
                layer.addChild(colorDim, 7);
            } else {
                colorDim.clear();
            }

            var heigth = wallCut.thickness / 10;
            var width = EntityDefaultPropertiesManager.getInstance().wallDefaultProperties.thickness / 10;
            var or = new cc.p(0, 0);
            or.y = +heigth / 2;
            or.x = +width / 2;
            var dest = new cc.p(0, 0);
            dest.x = -width / 2;
            dest.y = -heigth / 2;
            colorDim.drawRect(or, dest, cc.color(96, 125, 139));


            colorDim.setPosition(middle);

            var angle = Math.atan2(wallCut.wallDirection[0], wallCut.wallDirection[1]);
            angle = (angle - Math.PI * 0.5) * 180 / Math.PI;
            colorDim.setRotation(angle);
        }
    };

    static deleteCutDimension (saved?: any) {
        var name = 'CutDimension';
        if (saved) {
            name += 'Saved';
        }
        this.deleteDimension(name + '1');
        this.deleteDimension(name + '2');

        // Remove the dimensions to joineries
        this.deleteDimension(name + '3');
        this.deleteDimension(name + '4');

        var layer = PlanManager.getInstance().scrollWindow;
        var node = layer.grid.getChildByName('cutDimensionLayer');
        layer.grid.removeChild(node, true);
    };

    static drawCutDimension (cursorPos: any, wall: any, cursorPosWithoutSnap: any, saved?: any) {
        this.createCutDimension(cursorPos, wall, cursorPosWithoutSnap, saved);
    };

    static createObjectAroundDimension (arrangement: any, room: any) {
        var box = arrangement.boundingBox;

        if (!box) return;

        var objectPoint1 = math.vec3.create();
        var objectPoint2 = math.vec3.create();
        var objectPoint3 = math.vec3.create();
        var objectPoint4 = math.vec3.create();

        if (Math.abs(arrangement.angle) < SavaneConstants.Tolerance) {
            math.vec3.set(objectPoint1, (box[0][0] + box[1][0]) / 2, (box[0][1] + box[1][1]) / 2, 0);
            math.vec3.set(objectPoint2, (box[1][0] + box[2][0]) / 2, (box[1][1] + box[2][1]) / 2, 0);
            math.vec3.set(objectPoint3, (box[2][0] + box[3][0]) / 2, (box[2][1] + box[3][1]) / 2, 0);
            math.vec3.set(objectPoint4, (box[3][0] + box[0][0]) / 2, (box[3][1] + box[0][1]) / 2, 0);
        } else if (Math.abs(arrangement.angle - Math.PI / 2) < SavaneConstants.Tolerance) {
            math.vec3.set(objectPoint2, (box[0][0] + box[1][0]) / 2, (box[0][1] + box[1][1]) / 2, 0);
            math.vec3.set(objectPoint3, (box[1][0] + box[2][0]) / 2, (box[1][1] + box[2][1]) / 2, 0);
            math.vec3.set(objectPoint4, (box[2][0] + box[3][0]) / 2, (box[2][1] + box[3][1]) / 2, 0);
            math.vec3.set(objectPoint1, (box[3][0] + box[0][0]) / 2, (box[3][1] + box[0][1]) / 2, 0);
        } else if (Math.abs(arrangement.angle + Math.PI / 2) < SavaneConstants.Tolerance) {
            math.vec3.set(objectPoint4, (box[0][0] + box[1][0]) / 2, (box[0][1] + box[1][1]) / 2, 0);
            math.vec3.set(objectPoint1, (box[1][0] + box[2][0]) / 2, (box[1][1] + box[2][1]) / 2, 0);
            math.vec3.set(objectPoint2, (box[2][0] + box[3][0]) / 2, (box[2][1] + box[3][1]) / 2, 0);
            math.vec3.set(objectPoint3, (box[3][0] + box[0][0]) / 2, (box[3][1] + box[0][1]) / 2, 0);
        } else if (Math.abs(arrangement.angle + Math.PI) < SavaneConstants.Tolerance ||
            Math.abs(arrangement.angle - Math.PI) < SavaneConstants.Tolerance) {
            math.vec3.set(objectPoint3, (box[0][0] + box[1][0]) / 2, (box[0][1] + box[1][1]) / 2, 0);
            math.vec3.set(objectPoint4, (box[1][0] + box[2][0]) / 2, (box[1][1] + box[2][1]) / 2, 0);
            math.vec3.set(objectPoint1, (box[2][0] + box[3][0]) / 2, (box[2][1] + box[3][1]) / 2, 0);
            math.vec3.set(objectPoint2, (box[3][0] + box[0][0]) / 2, (box[3][1] + box[0][1]) / 2, 0);
        } else {
            objectPoint1 = math.vec3.clone(box[0]);
            objectPoint2 = math.vec3.clone(box[0]);
            objectPoint3 = math.vec3.clone(box[0]);
            objectPoint4 = math.vec3.clone(box[0]);
            for (var i = 0; i < box.length; i++) {
                if (box[i][0] > objectPoint1[0]) {
                    objectPoint1 = math.vec3.clone(box[i]);
                }
                if (box[i][1] > objectPoint2[1]) {
                    objectPoint2 = math.vec3.clone(box[i]);
                }
                if (box[i][0] < objectPoint3[0]) {
                    objectPoint3 = math.vec3.clone(box[i]);
                }
                if (box[i][1] < objectPoint4[1]) {
                    objectPoint4 = math.vec3.clone(box[i]);
                }
            }
        }

        var roomPoint1 = null;
        var roomPoint2 = null;
        var roomPoint3 = null;
        var roomPoint4 = null;

        var objectPoint1Horizontal = math.vec3.clone(objectPoint1);
        objectPoint1Horizontal[0] += 100;
        var objectPoint2Vertical = math.vec3.clone(objectPoint2);
        objectPoint2Vertical[1] += 100;
        var objectPoint3Horizontal = math.vec3.clone(objectPoint3);
        objectPoint3Horizontal[0] -= 100;
        var objectPoint4Vertical = math.vec3.clone(objectPoint4);
        objectPoint4Vertical[1] -= 100;

        var innerPoints = room.getInnerPointsList(false);
        var point1, point2, crossPoint, vt;
        for (var i = 0; i < innerPoints.length; i++) {
            point1 = innerPoints[i];
            point2 = innerPoints[(i + 1) % innerPoints.length];
            if (((point1[1] <= objectPoint1[1]) && (point2[1] > objectPoint1[1])) ||
                ((point1[1] > objectPoint1[1]) && (point2[1] <= objectPoint1[1]))) { // a downward crossing
                // compute  the actual edge-ray intersect x-coordinate
                vt = (objectPoint1[1] - point1[1]) / (point2[1] - point1[1]);
                if (objectPoint1[0] < point1[0] + vt * (point2[0] - point1[0])) {
                    if (roomPoint1 === null) {
                        roomPoint1 = SavaneMath.getCrossPoint(objectPoint1, objectPoint1Horizontal, point1, point2);
                    } else {
                        crossPoint = SavaneMath.getCrossPoint(objectPoint1, objectPoint1Horizontal, point1, point2);
                        if (crossPoint !== null && roomPoint1 !== null && math.vec3.dist(roomPoint1, objectPoint1) > math.vec3.dist(crossPoint, objectPoint1)) {
                            roomPoint1 = crossPoint;
                        }
                    }
                }
                vt = (objectPoint3[1] - point1[1]) / (point2[1] - point1[1]);
                if (objectPoint3[0] > point1[0] + vt * (point2[0] - point1[0])) {
                    if (roomPoint3 === null) {
                        roomPoint3 = SavaneMath.getCrossPoint(objectPoint3, objectPoint3Horizontal, point1, point2);
                    } else {
                        crossPoint = SavaneMath.getCrossPoint(objectPoint3, objectPoint3Horizontal, point1, point2);
                        if (crossPoint !== null && roomPoint3 !== null && math.vec3.dist(roomPoint3, objectPoint3) > math.vec3.dist(crossPoint, objectPoint3)) {
                            roomPoint3 = crossPoint;
                        }
                    }
                }
            }

            if (((point1[0] <= objectPoint2[0]) && (point2[0] > objectPoint2[0])) ||
                ((point1[0] > objectPoint2[0]) && (point2[0] <= objectPoint2[0]))) {
                vt = (objectPoint2[0] - point1[0]) / (point2[0] - point1[0]);
                if (objectPoint2[1] < point1[1] + vt * (point2[1] - point1[1])) {
                    if (roomPoint2 === null) {
                        roomPoint2 = SavaneMath.getCrossPoint(objectPoint2, objectPoint2Vertical, point1, point2);
                    } else {
                        crossPoint = SavaneMath.getCrossPoint(objectPoint2, objectPoint2Vertical, point1, point2);
                        if (crossPoint !== null && roomPoint2 !== null && math.vec3.dist(roomPoint2, objectPoint2) > math.vec3.dist(crossPoint, objectPoint2)) {
                            roomPoint2 = crossPoint;
                        }
                    }
                }
                vt = (objectPoint4[0] - point1[0]) / (point2[0] - point1[0]);
                if (objectPoint4[1] > point1[1] + vt * (point2[1] - point1[1])) {
                    if (roomPoint4 === null) {
                        roomPoint4 = SavaneMath.getCrossPoint(objectPoint4, objectPoint4Vertical, point1, point2);
                    } else {
                        crossPoint = SavaneMath.getCrossPoint(objectPoint4, objectPoint4Vertical, point1, point2);
                        if (crossPoint !== null && roomPoint3 !== null && math.vec3.dist(roomPoint3, objectPoint3) > math.vec3.dist(crossPoint, objectPoint4)) {
                            roomPoint4 = crossPoint;
                        }
                    }
                }
            }
        }

        var scale = PlanManager.getInstance().getZoomScale();
        var normal = cc.p(0, 1);

        if (roomPoint1 !== null) {
            var dist1 = math.vec3.dist(objectPoint1, roomPoint1);
            point1 = this.convertToCocosCoord(objectPoint1);
            point2 = this.convertToCocosCoord(roomPoint1);
            this.createDimension('ObjectAroundDimensionDimension1', '' + Math.floor(dist1 / 10) + 'cm', point1, point2, normal, 0, scale);
        }
        if (roomPoint3 !== null) {
            var dist3 = math.vec3.dist(objectPoint3, roomPoint3);
            point1 = this.convertToCocosCoord(objectPoint3);
            point2 = this.convertToCocosCoord(roomPoint3);
            this.createDimension('ObjectAroundDimensionDimension3', '' + Math.floor(dist3 / 10) + 'cm', point1, point2, normal, 0, scale);
        }
        normal = cc.p(1, 0);
        if (roomPoint2 !== null) {
            var dist2 = math.vec3.dist(objectPoint2, roomPoint2);
            point1 = this.convertToCocosCoord(objectPoint2);
            point2 = this.convertToCocosCoord(roomPoint2);
            this.createDimension('ObjectAroundDimensionDimension2', '' + Math.floor(dist2 / 10) + 'cm', point1, point2, normal, 0, scale);
        }
        if (roomPoint4 !== null) {
            var dist4 = math.vec3.dist(objectPoint4, roomPoint4);
            point1 = this.convertToCocosCoord(objectPoint4);
            point2 = this.convertToCocosCoord(roomPoint4);
            this.createDimension('ObjectAroundDimensionDimension4', '' + Math.floor(dist4 / 10) + 'cm', point1, point2, normal, 0, scale);
        }
    };

    static deleteObjectAroundDimension () {
        this.deleteDimension('ObjectAroundDimensionDimension1');
        this.deleteDimension('ObjectAroundDimensionDimension2');
        this.deleteDimension('ObjectAroundDimensionDimension3');
        this.deleteDimension('ObjectAroundDimensionDimension4');
    };

    static drawObjectAroundDimension (arrangement: any, room: any) {
        //static deleteArrangementDimension();
        this.createObjectAroundDimension(arrangement, room);
    };

    static drawSafeZone () {
        var layer = PlanManager.getInstance().scrollWindow.grid;

        //Retrieve wall in grid
        var safeZoneNode = layer.getChildByName("safeZone");
        if (safeZoneNode === null) {
            safeZoneNode = new SafeZoneNode();
            safeZoneNode.setName("safeZone");
            layer.addChild(safeZoneNode, 100007);

            var cursorPosition = PlanManager.getInstance()._uiState.cursorPosition;

            safeZoneNode.setPosition(cursorPosition[0] / 10, cursorPosition[1] / 10)
        }
    };

    static updateSafeZone (cursorPosition: any) {
        var layer = PlanManager.getInstance().scrollWindow.grid;

        //Retrieve wall in grid
        var safeZoneNode = layer.getChildByName("safeZone");
        if (safeZoneNode !== null) {
            safeZoneNode.setPosition(cursorPosition[0] / 10, cursorPosition[1] / 10);
        }
    };

    static deleteSafeZone () {
        var layer = PlanManager.getInstance().scrollWindow.grid;

        var node = layer.getChildByName("safeZone");
        if (node !== null) {
            node.removeFromParent();
        }
    };

    

    static drawMeasure () {
        var cursorPosition = PlanManager.getInstance()._uiState.unsnappedCursorPosition;

        if (!this.beginMeasure) {
            this.beginMeasure = math.vec3.create();
            this.beginMeasure[0] = cursorPosition[0];
            this.beginMeasure[1] = cursorPosition[1];
        }

        var currentEnd = math.vec3.create();
        currentEnd[0] = cursorPosition[0];
        currentEnd[1] = cursorPosition[1];
        var distance = math.vec3.dist(this.beginMeasure, currentEnd);

        var point1 = this.convertToCocosCoord(this.beginMeasure);
        var point2 = this.convertToCocosCoord(currentEnd);
        var scale = PlanManager.getInstance().getZoomScale();
        var normal = cc.p(0, 1);

        this.deleteDimension('Measure');
        if (Math.round(distance / 10) > 0) {
            this.createDimension('Measure', '' + Math.round(distance / 10) + 'cm', point1, point2, normal, 0, scale);
        }
    };

    static deleteMeasure () {
    this.beginMeasure = null;
    this.deleteDimension('Measure');
    };

    static deleteJoinery (joineryId: any) {
        if (PlanManager.getInstance().frontViewLayer.isVisible()) {
            FrontViewManager.deleteJoinery(joineryId);
        }

        this.deleteJoineryDimension(joineryId);

        /*var name = 'Joinery' + joineryId;
        var layer = PlanManager.getInstance().scrollWindow;
        var sprite = layer.grid.getChildByName(name);
        layer.grid.removeChild(sprite, true);*/
        this.deleteJoineryExtremity('SelectedJoineryPoint');
        this.deleteJoineryExtremity('SelectedJoineryPoint2');
    };

    static createJoineryDimension (joinery: any, deco?: any) {
        var i;
        if (joinery.wall !== null) {
            var wall = joinery.wall;

            var firstPointIsJoinery = false;
            var lastPointIsJoinery = false;
            var pos = joinery.position;
            pos[2] = 0;
            var distToWall = math.vec3.dist(wall.begin, pos) - joinery.length / 2;

            //Extract joinery extremities
            var beginJoinery = math.vec3.create();
            var endJoinery = math.vec3.create();

            if (joinery.joineryType === SceneConstants.JoineryType.velux) {
                var joineryProjectedPos = SavaneMath.getProjection(joinery.position, wall.begin, wall.end);
                distToWall = math.vec3.dist(wall.begin, joineryProjectedPos) - joinery.length / 2;
            }

            math.vec3.set(beginJoinery, wall.begin[0] + wall.wallDirection[0] * distToWall, wall.begin[1] + wall.wallDirection[1] * distToWall, 0);
            math.vec3.set(endJoinery, wall.begin[0] + wall.wallDirection[0] * (distToWall + joinery.length), wall.begin[1] + wall.wallDirection[1] * (distToWall + joinery.length), 0);

            //Extract wall extremities
            var firstPoint = math.vec3.clone(wall.begin);
            var lastPoint = math.vec3.clone(wall.end);

            //Calculate distance to wall border
            var normal = cc.p(-wall.wallDirection[1], wall.wallDirection[0]);
            var decalPoint = math.vec3.create();
            math.vec3.set(decalPoint, wall.begin[0] - wall.wallDirection[1], wall.begin[1] + wall.wallDirection[0], 0);
            var invertMat = math.mat4.create();
            math.mat4.invert(invertMat, wall.globalMatrix);
            var localNormal = math.vec3.create();
            math.vec3.transformMat4(localNormal, decalPoint, invertMat);
            var cuttedBBox = wall.boundingBoxCut;
            if (localNormal[1] > 0) {
                math.vec3.copy(firstPoint, cuttedBBox[0]);
                math.vec3.copy(lastPoint, cuttedBBox[3]);
                /*firstPoint[0] += normal.x * wall.thickness * 0.5;
                firstPoint[1] += normal.y * wall.thickness * 0.5;
                lastPoint[0] += normal.x * wall.thickness * 0.5;
                lastPoint[1] += normal.y * wall.thickness * 0.5;*/
            } else {
                math.vec3.copy(firstPoint, cuttedBBox[1]);
                math.vec3.copy(lastPoint, cuttedBBox[2]);
                /*firstPoint[0] -= normal.x * wall.thickness * 0.5;
                firstPoint[1] -= normal.y * wall.thickness * 0.5;
                lastPoint[0] -= normal.x * wall.thickness * 0.5;
                lastPoint[1] -= normal.y * wall.thickness * 0.5;*/
            }
            /*firstPoint[0] -= normal.x * wall.thickness * 0.5;
            firstPoint[1] -= normal.y * wall.thickness * 0.5;
            lastPoint[0] -= normal.x * wall.thickness * 0.5;
            lastPoint[1] -= normal.y * wall.thickness * 0.5;*/

            //Check if a joinery is blocking and calculate distance
            for (i = 0; i < wall.joineries.length; i++) {
                if (wall.joineries[i].id !== joinery.id) {
                    if (math.vec3.dist(wall.begin, wall.joineries[i].position) - wall.joineries[i].length / 2 < distToWall) {
                        if (math.vec3.dist(wall.joineries[i].position, beginJoinery) + wall.joineries[i].length / 2 < math.vec3.dist(firstPoint, beginJoinery)) {
                            if (wall.joineries[i].joineryType === SceneConstants.JoineryType.velux) {
                                var joineryProjectedPos = SavaneMath.getProjection(wall.joineries[i].position, wall.begin, wall.end);

                                math.vec3.set(firstPoint, joineryProjectedPos[0] + wall.wallDirection[0] * wall.joineries[i].length / 2,
                                    joineryProjectedPos[1] + wall.wallDirection[1] * wall.joineries[i].length / 2, 0);
                            }
                            else {
                                math.vec3.set(firstPoint, wall.joineries[i].position[0] + wall.wallDirection[0] * wall.joineries[i].length / 2,
                                    wall.joineries[i].position[1] + wall.wallDirection[1] * wall.joineries[i].length / 2, 0);
                            }
                            firstPointIsJoinery = true;
                        }
                    }
                    else {
                        if (math.vec3.dist(wall.joineries[i].position, endJoinery) - wall.joineries[i].length / 2 < math.vec3.dist(lastPoint, endJoinery)) {
                            if (wall.joineries[i].joineryType === SceneConstants.JoineryType.velux) {
                                var joineryProjectedPos = SavaneMath.getProjection(wall.joineries[i].position, wall.begin, wall.end);

                                math.vec3.set(lastPoint, joineryProjectedPos[0] - wall.wallDirection[0] * wall.joineries[i].length / 2,
                                    joineryProjectedPos[1] - wall.wallDirection[1] * wall.joineries[i].length / 2, 0);
                            }
                            else {
                                math.vec3.set(lastPoint, wall.joineries[i].position[0] - wall.wallDirection[0] * wall.joineries[i].length / 2,
                                    wall.joineries[i].position[1] - wall.wallDirection[1] * wall.joineries[i].length / 2, 0);
                            }
                            lastPointIsJoinery = true;
                        }
                    }
                }
            }
            if (firstPointIsJoinery) {
                firstPoint[0] += normal.x * wall.thickness * 0.5;
                firstPoint[1] += normal.y * wall.thickness * 0.5;
            }
            if (lastPointIsJoinery) {
                lastPoint[0] += normal.x * wall.thickness * 0.5;
                lastPoint[1] += normal.y * wall.thickness * 0.5;
            }
            beginJoinery[0] += (wall.wallDirection[1] * -wall.shiftOffset) + normal.x * wall.thickness * 0.5;
            beginJoinery[1] += (wall.wallDirection[0] * wall.shiftOffset) + normal.y * wall.thickness * 0.5;
            endJoinery[0] += (wall.wallDirection[1] * -wall.shiftOffset) + normal.x * wall.thickness * 0.5;
            endJoinery[1] += (wall.wallDirection[0] * wall.shiftOffset) + normal.y * wall.thickness * 0.5;

            var beginW = this.convertToCocosCoord(firstPoint);
            var beginJ = this.convertToCocosCoord(beginJoinery);
            var endJ = this.convertToCocosCoord(endJoinery);
            var endW = this.convertToCocosCoord(lastPoint);

            var scale = PlanManager.getInstance().getZoomScale();
            var dim1 = this.createDimension('JoineryDimension1', '', beginW, beginJ, normal, Utils.DIMENSION_DIST * 1.5, scale, deco);
            dim1.setTag(joinery.id);
            var dim2 = this.createDimension('JoineryDimension2', '', beginJ, endJ, normal, Utils.DIMENSION_DIST * 3.0, scale, deco);
            dim2.setTag(joinery.id);
            var dim3 = this.createDimension('JoineryDimension3', '', endJ, endW, normal, Utils.DIMENSION_DIST * 1.5, scale, deco);
            dim3.setTag(joinery.id);

            firstPointIsJoinery = false;
            lastPointIsJoinery = false;

            normal.x = -normal.x;
            normal.y = -normal.y;
            if (localNormal[1] < 0) {
                math.vec3.copy(firstPoint, cuttedBBox[0]);
                math.vec3.copy(lastPoint, cuttedBBox[3]);
            } else {
                math.vec3.copy(firstPoint, cuttedBBox[1]);
                math.vec3.copy(lastPoint, cuttedBBox[2]);
            }
            /*firstPoint[0] -= normal.x * wall.thickness * 0.5;
            firstPoint[1] -= normal.y * wall.thickness * 0.5;
            lastPoint[0] -= normal.x * wall.thickness * 0.5;
            lastPoint[1] -= normal.y * wall.thickness * 0.5;*/

            //Check if a joinery is blocking and calculate distance
            for (i = 0; i < wall.joineries.length; i++) {
                if (wall.joineries[i].id !== joinery.id) {
                    if (math.vec3.dist(wall.begin, wall.joineries[i].position) - wall.joineries[i].length / 2 < distToWall) {
                        if (math.vec3.dist(wall.joineries[i].position, beginJoinery) + wall.joineries[i].length / 2 < math.vec3.dist(firstPoint, beginJoinery)) {
                            if (wall.joineries[i].joineryType === SceneConstants.JoineryType.velux) {
                                var joineryProjectedPos = SavaneMath.getProjection(wall.joineries[i].position, wall.begin, wall.end);

                                math.vec3.set(firstPoint, joineryProjectedPos[0] + wall.wallDirection[0] * wall.joineries[i].length / 2,
                                    joineryProjectedPos[1] + wall.wallDirection[1] * wall.joineries[i].length / 2, 0);
                            }
                            else {
                                math.vec3.set(firstPoint, wall.joineries[i].position[0] + wall.wallDirection[0] * wall.joineries[i].length / 2,
                                    wall.joineries[i].position[1] + wall.wallDirection[1] * wall.joineries[i].length / 2, 0);
                            }
                            firstPointIsJoinery = true;
                        }
                    }
                    else {
                        if (math.vec3.dist(wall.joineries[i].position, endJoinery) - wall.joineries[i].length / 2 < math.vec3.dist(lastPoint, endJoinery)) {
                            if (wall.joineries[i].joineryType === SceneConstants.JoineryType.velux) {
                                var joineryProjectedPos = SavaneMath.getProjection(wall.joineries[i].position, wall.begin, wall.end);

                                math.vec3.set(lastPoint, joineryProjectedPos[0] - wall.wallDirection[0] * wall.joineries[i].length / 2,
                                    joineryProjectedPos[1] - wall.wallDirection[1] * wall.joineries[i].length / 2, 0);
                            }
                            else {
                                math.vec3.set(lastPoint, wall.joineries[i].position[0] - wall.wallDirection[0] * wall.joineries[i].length / 2,
                                    wall.joineries[i].position[1] - wall.wallDirection[1] * wall.joineries[i].length / 2, 0);
                            }
                            lastPointIsJoinery = true;
                        }
                    }
                }
            }

            if (firstPointIsJoinery) {
                firstPoint[0] += normal.x * wall.thickness * 0.5;
                firstPoint[1] += normal.y * wall.thickness * 0.5;
            }
            if (lastPointIsJoinery) {
                lastPoint[0] += normal.x * wall.thickness * 0.5;
                lastPoint[1] += normal.y * wall.thickness * 0.5;
            }
            beginJoinery[0] += normal.x * wall.thickness;
            beginJoinery[1] += normal.y * wall.thickness;
            endJoinery[0] += normal.x * wall.thickness;
            endJoinery[1] += normal.y * wall.thickness;
            beginW = this.convertToCocosCoord(firstPoint);
            beginJ = this.convertToCocosCoord(beginJoinery);
            endJ = this.convertToCocosCoord(endJoinery);
            endW = this.convertToCocosCoord(lastPoint);

            var dim4 = this.createDimension('JoineryDimension4', '', beginW, beginJ, normal, Utils.DIMENSION_DIST * 1.0, scale, deco);
            dim4.setTag(joinery.id);
            //  var dim5 = static createDimension('JoineryDimension5', '', beginJ, endJ, normal, Utils.DIMENSION_DIST * 2.5, scale);
            //  dim5.setTag(joinery.id);
            var dim6 = this.createDimension('JoineryDimension6', '', endJ, endW, normal, Utils.DIMENSION_DIST * 1.0, scale, deco);
            dim6.setTag(joinery.id);
        } else {
            this.deleteJoineryDimension(joinery.id);
        }
    };

    static deleteJoineryDimension (joineryId: number) {
        this.deleteDimension('JoineryDimension1');
        this.deleteDimension('JoineryDimension2');
        this.deleteDimension('JoineryDimension3');
        this.deleteDimension('JoineryDimension4');
        //   static deleteDimension('JoineryDimension5');
        this.deleteDimension('JoineryDimension6');
    };

    static drawJoineryDimension (joinery: any) {
        //static deleteJoineryDimension(joinery.id);
        this.createJoineryDimension(joinery);
    };

    static drawAreaDimensions (id: any, vertices: any) {
        if (vertices.length < 2) {
            return [];//Not enough point to make dimensions
        }
        var list = [];
        //Temp value for vertices
        var vs, ve;
        //Start at 1 to avoid first point
        for (var i = 0; i < vertices.length; i++) {
            if (i === 0) {//Special behaviour for i === 0
                vs = vertices[vertices.length - 1];
                ve = vertices[0];
            } else {
                vs = vertices[i - 1];
                ve = vertices[i];
            }
            //Create dimensions for this segment (name, label, begin, end, normal, dist, labelScale, deco, decoObj)
            var d = math.vec3.dist(vs, ve);
            var norm = new cc.p(-(vs[1] - ve[1]) / d, -(ve[0] - vs[0]) / d);
            var dim = this.createDimension('AreaDimension' + id + '_' + i, '' + (d / 10),
                this.convertToCocosCoord(vs), this.convertToCocosCoord(ve), norm, 10, 1.0);
            //Add dim node to list
            list.push(dim);
        }
        return list;
    }
    static deleteAreaDimensions (id: any, vertices: any) {
        //Start at 1 to avoid first point
        for (var i = 0; i <= vertices.length; i++) {
            this.deleteDimension('AreaDimension' + id + '_' + i);
        }
    }

    static unselectItems (entities: any) {
        var i;

        eventsManager.instance.dispatch(Events.UNSELECT_WEBGL_ITEMS, entities);
        eventsManager.instance.dispatch(Events.DESIGNER_FILTER_SELECTION_CHANGED);

        if (entities !== null && entities.length > 0) {
            if (PlanManager.getInstance().frontViewLayer.isVisible()) {
                for (i = 0; i < entities.length; i++) {
                    FrontViewManager.unselectDecoration(entities[i]);
                }
            } else {
                //
                for (i = 0; i < entities.length; i++) {
                    var node = EntityManager.getInstance().getNode(entities[i]);
                    if (node !== null) {
                        node.setSelected(false);
                        switch (entities[i].entityType) {
                            case SceneConstants.EntityType.Room:
                                this.drawRoom(entities[i], false);
                                break;
                            case SceneConstants.EntityType.Wall:
                                this.drawWall(entities[i], true, false, false);
                                break;
                            case SceneConstants.EntityType.ArrangementObject:
                            case SceneConstants.EntityType.ArrangementGroup:
                                if (node !== null) {
                                    node.deleteMenu();
                                }
                                break;
                        }
                    }
                }
            }
        }
    };

    static selectItems (entities: any) {
        var i;

        eventsManager.instance.dispatch(Events.SELECT_WEBGL_ITEMS, entities);
        eventsManager.instance.dispatch(Events.DESIGNER_FILTER_SELECTION_CHANGED);

        if (entities !== null && entities.length > 0) {
            if (PlanManager.getInstance().frontViewLayer.isVisible()) {
                for (i = 0; i < entities.length; i++) {
                    FrontViewManager.selectDecoration(entities[i]);
                }
            } else {
                for (i = 0; i < entities.length; i++) {
                    var node = EntityManager.getInstance().getNode(entities[i]);
                    if (node !== null) {
                        node.setSelected(true);
                    }

                    switch (entities[i].entityType) {
                        case SceneConstants.EntityType.Room:
                            var roomToDraw = [];
                            roomToDraw.push(entities[i]);
                            var indexMinArea;
                            while (roomToDraw.length !== 0) {
                                indexMinArea = 0;
                                for (i = 0; i < roomToDraw.length; i++) {
                                    if (roomToDraw[indexMinArea].area < roomToDraw[i].area) {
                                        indexMinArea = i;
                                    }
                                }
                                this.drawRoom(roomToDraw[indexMinArea], true);
                                roomToDraw.splice(indexMinArea, 1);
                            }
                            break;
                        case SceneConstants.EntityType.Wall:
                            this.drawWall(entities[i], true, true, false);
                            break;

                        case SceneConstants.EntityType.ArrangementObject:
                        case SceneConstants.EntityType.ArrangementGroup:
                            if (node !== null) {
                                node.addMenu();
                            }
                            break;
                    }
                }
            }
        }
    };

    /**
     * Draw poly for filling room
     * @param room
     * @param isSelected
     * @param roomsIgnored
     */
    static drawRoom (room: any, isSelected?: any, roomsIgnored?: any, mustDrawWall?: any, mustDrawBiggerRoom?: any) {
        room.invalidateRoomPointsList();

        var i, j;
        var layer = PlanManager.getInstance().scrollWindow;
        var drawnode: EntityNode | null = EntityManager.getInstance().getNode(room);
        if (mustDrawWall === undefined) {
            mustDrawWall = true;
        }
        if (!room.parent) {
            return false;
        }
        var triangles = room.triangulate();
        if (triangles === null || triangles.length === 0) {
            //TODO Keep the error log or try to avoid thoose case ? (Move a wall and make a room flat, no area)
            if (drawnode !== null) {
                drawnode._trianglesBuffer = null;
            }
            console.error('Triangulate of Room failed and return null');
            return false;
        }
        for (i = 0; i < triangles.length; i++) {
            triangles[i][0] = this.convertToCocosCoord(triangles[i][0]);
            triangles[i][1] = this.convertToCocosCoord(triangles[i][1]);
            triangles[i][2] = this.convertToCocosCoord(triangles[i][2]);
        }


        if (drawnode === null) {
            //FIXME Temporary coexist 2 tree for entities
            drawnode = EntityManager.getInstance().createNode(room, undefined);
        }
        if (drawnode !== null) {
            if (room.isOrdered) {
                drawnode.isOrdered = true;
            }
            //Update coordinates of vertices and uv and change color if selected
            drawnode.changeSelectedState(isSelected, triangles, layer.getZoomScale());
        }

        //Search for others room to update ??
        if (mustDrawBiggerRoom === null || mustDrawBiggerRoom === undefined || mustDrawBiggerRoom) {
            var roomList = PlanManager.getInstance().world.currentScene?.currentFloor; //edited
            if (roomList?.roomArray) {
                for (i = 0; i < roomList.roomArray.length; i++) {
                    if (SavaneMath.isWallInRoom(room.walls[0], roomList.roomArray[i])) {
                        this.drawRoom(roomList.roomArray[i], false, [], false, false);
                    }
                }
            }
        }

        if (mustDrawWall) {
            if (isSelected) {
                for (i = 0; i < room.walls.length; i++) {
                    this.drawWall(room.walls[i], true, false, true, room.id, null);
                }
            }
            else {
                for (i = 0; i < room.walls.length; i++) {
                    this.drawWall(room.walls[i], true, false, true, -1, null);
                }
            }
        }
        //Draw chips
        if (drawnode !== null) {
            var funcs = room.functionalityChips;
            const currentFloor = PlanManager.getInstance().world.currentScene?.currentFloor;
            for (j = 0; j < funcs.length; j++) {
                var chip = funcs[j];
                if (chip.isOnPlan && currentFloor) {
                    this.drawFunctionalityChip(chip, chip.isValid(currentFloor), false, drawnode);
                }
            }
        }

        return drawnode;
    };
    /**
     * Draw poly for filling room
     * @param room
     * @param isSelected
     * @param roomsIgnored
     */
    static drawScreenshotRoom (room: Room) {
        var i, j;
        var layer = PlanManager.getInstance().scrollWindow;
        var drawnode = EntityManager.getInstance().getNode(room); //Utils.getChildByNameRecursivly(layer, 'Room' + room.id);
        var triangles = room.triangulate();
        if (triangles === null || triangles.length === 0) {
            //TODO Keep the error log or try to avoid thoose case ? (Move a wall and make a room flat, no area)
            if (drawnode) {
                (drawnode as any)._trianglesBuffer = null;
            }
            console.error('Triangulate of Room failed and return null');
            return false;
        }
        for (i = 0; i < triangles.length; i++) {
            triangles[i][0] = this.convertToCocosCoord(triangles[i][0]);
            triangles[i][1] = this.convertToCocosCoord(triangles[i][1]);
            triangles[i][2] = this.convertToCocosCoord(triangles[i][2]);
        }
        if (drawnode) {
            (drawnode as any).screenshot = true;
            //Update coordinates of vertices and uv and change color if selected
            drawnode.changeSelectedState(false, triangles, layer.getZoomScale());
        }
        for (i = 0; i < room.walls.length; i++) {
            this.drawWall(room.walls[i], true, false, true, -1, null);
        }
        //Draw chips
        //TODO Refacto screenshot
        //Draw chips
        var funcs = room.functionalityChips;
        for (j = 0; j < funcs.length; j++) {
            var chip = funcs[j];
            if (chip.isOnPlan) {
                this.deleteFunctionalityChip(chip);
            }
        }
        return drawnode;
    };

    static updateRooms (rooms: Room[], mustDrawWall?: boolean) {
        if (mustDrawWall === undefined)
            mustDrawWall = true;
        for (var i = 0; i < rooms.length; i++) {
            this.drawRoom(rooms[i], false, rooms, mustDrawWall);
        }
    };

    static setObjectOfClickedDimension (dimension: DimensionNode) {
        if (dimension === null) {
            this.objectOfClickedDimension = null;
        } else {
            this.dimensionClicked = dimension;
            const currentScene = PlanManager.getInstance().world.currentScene;
            switch (dimension.getName()) {
                case 'JoineryDimension1':
                    this.dimensionClickedType = this.DimensionType.Joinery1;
                    this.objectOfClickedDimension = currentScene ? {join: joineryManager.getJoinery(dimension.getTag(), currentScene)} : null;
                    break;
                case 'JoineryDimension2':
                    this.dimensionClickedType = this.DimensionType.Joinery2;
                    this.objectOfClickedDimension = currentScene ? {join: joineryManager.getJoinery(dimension.getTag(), currentScene)} : null;
                    break;
                case 'JoineryDimension3':
                    this.dimensionClickedType = this.DimensionType.Joinery3;
                    this.objectOfClickedDimension = currentScene ? {join: joineryManager.getJoinery(dimension.getTag(), currentScene)} : null;
                    break;
                case 'JoineryDimension4':
                    this.dimensionClickedType = this.DimensionType.Joinery1;
                    this.objectOfClickedDimension = currentScene ? {join: joineryManager.getJoinery(dimension.getTag(), currentScene)} : null;
                    break;
                case 'JoineryDimension5':
                    this.dimensionClickedType = this.DimensionType.Joinery2;
                    this.objectOfClickedDimension = currentScene ? {join: joineryManager.getJoinery(dimension.getTag(), currentScene)} : null;
                    break;
                case 'JoineryDimension6':
                    this.dimensionClickedType = this.DimensionType.Joinery3;
                    this.objectOfClickedDimension = currentScene ? {join: joineryManager.getJoinery(dimension.getTag(), currentScene)} : null;
                    break;
                case 'wallDimTop':
                    /*static dimensionClickedType = static DimensionType.Walls;
                    var wall = PlanManager.getInstance().world.currentScene!.currentFloor!.getWall(dimension.getTag());
                    //Put it in an array
                    if (wall) {
                        static objectOfClickedDimension = {
                            walls: [wall],
                            top: [true]
                        };
                    }
                    else {
                        static objectOfClickedDimension = null;
                    }*/
                    break;
                case 'wallDimBot':
                    /*static dimensionClickedType = static DimensionType.Walls;
                    var wall = PlanManager.getInstance().world.currentScene!.currentFloor!.getWall(dimension.getTag());
                    //Put it in an array
                    if (wall) {
                        static objectOfClickedDimension = {
                            walls: [wall],
                            top: [false]
                        };
                    }
                    else {
                        static objectOfClickedDimension = null;
                    }*/
                    break;
                case 'techElementDimension1':
                    this.dimensionClickedType = this.DimensionType.TechElement;
                    var tech = currentScene ? arrangementManager.getTechnicalElement(dimension.getTag(), currentScene) : null;
                    if (tech) {
                        this.objectOfClickedDimension = {
                            techElem: [tech],
                            dir: 'length'
                        };
                    }
                    else {
                        this.objectOfClickedDimension = null;
                    }
                    break;
                case 'techElementDimension2':
                    this.dimensionClickedType = this.DimensionType.TechElement;
                    var tech2 = currentScene ? arrangementManager.getTechnicalElement(dimension.getTag(), currentScene) : null;
                    if (tech2) {
                        this.objectOfClickedDimension = {
                            techElem: [tech2],
                            dir: 'width'
                        };
                    }
                    else {
                        this.objectOfClickedDimension = null;
                    }
                    break;

                default:
                    /*if (dimension.getName().indexOf('Room') >= 0) {
                        //Room dimensions
                        var dimensionList = dimension.getTag();
                        var arraySide = [];
                        if (dimensionList[0].id === dimensionList[1].id) {
                            //Single wall modified
                            arraySide[0] = !dimensionList[0][0].isCorner(dimensionList[0][1].begin);
                            arraySide[1] = arraySide[0];
                        } else {
                            //Merged wall modified

                            arraySide[0] = dimensionList[1][0].isCorner(dimensionList[0][1].end, SavaneJSConstants.PositionTolerance);
                            arraySide[1] = dimensionList[0][1].isCorner(dimensionList[1][0].begin, SavaneJSConstants.PositionTolerance);
                        }
                        static dimensionClickedType = static DimensionType.Walls;
                        static objectOfClickedDimension = {
                            walls: [dimensionList[0][1], dimensionList[1][0]],
                            top: arraySide
                        };
                    } else {
                        static objectOfClickedDimension = null;
                    }*/
                    break;
            }
        }
    };
    static getObjectOfClickedDimension (): object | null {
        var obj = this.objectOfClickedDimension;
        this.objectOfClickedDimension = null;
        return obj;
    };
    /**
     * draw a functionality chip
     */
    static drawFunctionalityChip (chip: FunctionalityChip, isValid: boolean, isSelected: boolean, parent: EntityNode) {
        var layer = PlanManager.getInstance().scrollWindow.grid;
        var name = /*'FunctionalityChip' + */chip.id;
        // var sprite = layer.getChildByName(name);
        var spriteFound = Utils.getChildByNameRecursivly(layer, name.toString());
        var sprite: EntityNode | FunctionalityChipNode;
        if (spriteFound === null) {
            //Create chip
            sprite = new FunctionalityChipNode(chip);
            sprite.setAnchorPoint(new cc.p(0.5, 0.5));
            sprite.setName(name);
            layer.addChild(sprite, 4);
        } else {
            sprite = spriteFound as any;
        }
        if (parent !== undefined && sprite.parent !== parent) {
            sprite.removeFromParent();
            parent.addChild(sprite, 4);
        }
        var cocosPosition = this.convertToCocosCoord(chip.position);
        //cocosPosition.y += sprite.getContentSize().height * sprite.getScaleY();
        sprite.setPosition(cocosPosition);
        sprite.setVisible(!PlanManager.getInstance().hideChips);
        sprite.setInvalid(isValid);

    };
    /**
     * remove a functionality chip
     */
    static deleteFunctionalityChip (chip: FunctionalityChip) {
        var layer = PlanManager.getInstance().scrollWindow.grid;
        var name = /*'FunctionalityChip' + */chip.id;
        var sprite = Utils.getChildByNameRecursivly(layer, name.toString());
        if (sprite !== null) {
            //Create chip
            sprite.removeFromParent();
        }
    };
    /**
     * Remove entity from screen
     */
    static removeEntity (type: number, id: number) {
        //Set prefix
        var prefix = '';
        switch (type) {
            case SceneConstants.EntityType.RenderCamera:
                prefix = 'Camera';
                break;
            case SceneConstants.EntityType.Comment:
                prefix = 'Comment';
                break;
        }
        //Remove node
        var layer = PlanManager.getInstance().scrollWindow;
        var name = prefix + id;
        var sprite = Utils.getChildByNameRecursivly(layer as any, name);
        if (sprite !== null) {
            //Create chip
            sprite.removeFromParent();
        }
    };
}


